import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    titleSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
    },
    pageTitleFullWidth: {
        display: 'flex',
        alignItems: 'center',
        color: 'black',
        fontSize: 36,
        marginBottom: 12,
        fontFamily: 'GreedWide-Heavy, sans-serif',
        textTransform: 'uppercase',
        [theme.breakpoints.down('sm')]: {
            fontSize: 26,
            textAlign: 'center',
            lineHeight: 1.2
        }
    },
    pageSubTitle: {
        fontSize: 18,
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
            textAlign: 'center',
            width: '100%'
        }
    },
    whyUsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 42
    },
    theyTrustUs: {
        marginTop: 100,
        padding: '0px 0px',
        [theme.breakpoints.down('sm')]: {
            marginTop: 60
        }
    },
    partnerBox: {
        alignItems: 'center'
    },
    partnerImageBox: {
        width: '100%',
        '& a': {
            display: 'flex'
        }
    },
    partnerImage: {
        width: '40%',
        objectFit: 'contain',
        margin: '1rem auto',
        cursor: 'pointer',
        '&:hover': {
            transform: 'scale(1.05)',
            transition: '.2s'
        },
        [theme.breakpoints.up('md')]: {
            width: '65%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '70%'
        }
    }
}))
